//import { Route, Router, history } from 'react-router';
import { Route, Router, BrowserRouter, Switch } from 'react-router-dom';

import './BCC.css'
import React, { Component } from 'react'
import Event from './components/event/Event'
import EventDemo from './components/event/EventDemo';
import Events from './components/Events'
import Chapter from './components/chapter/Chapter'
import SideBarLayout from './components/SideBarLayout'
import SimpleLayout from './components/SimpleLayout'
import EventsSideBar from './components/EventsSideBar'
import Calendar from './components/Calendar'
import NavMenu from './components/NavMenu'
import ComingSoon from './components/ComingSoon'
import { createStore, withStore } from './components/store'
import SignIn from './components/account/SignIn';
import SignUp from './components/account/SignUp';

import CalendarSideBar from './components/CalendarSideBar';
import Chapters from './components/Chapters';
import Members from './components/Members';
import Member from './components/member/Member';
import Admin from './components/member/Admin';
import MemberEvent from './components/member/MemberEvent';
import MembersSideBar from './components/MembersSideBar'
import TestPage from './components/TestPage';
import MembersReport from './components/reports/MembersReport';
import EventsByType from './components/reports/EventsByType';
import VeteransBySite from './components/reports/VeteransBySite';
import VeteransAttendence from './components/reports/VeteransAttendence';
import ReportsList from './components/reports/ReportsList';
import PasswordReset from './components/account/PasswordReset';
import VeteransByEventType from './components/reports/VeteransByEventType';
import Services from './components/Service/Services';
import Service from './components/Service/Service'
import ServiceSideBar from './components/Service/ServiceSideBar';
import EventTypes from './components/event/EventTypes'
import EventType from './components/event/EventType'


import Checkout from './components/Payment/Checkout'

import { Elements, StripeProvider } from 'react-stripe-elements/dist/react-stripe-elements';
import PaymentReport from './components/reports/PaymentReport';
import ContactUs from './components/ContactUs';


const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
class App extends Component {
    static displayName = App.name;

    constructor(props) {
        super(props);
        this.state = {
            chapterFilter: [],
            stripe: null
        };

        //this.state = { logginStatus: true };
        this.events = [
            "load",
            "mousemove",
            "mousedown",
            "click",
            "scroll",
            "keypress"
        ];

        //this.navBarRef = null;
        //this.warn = this.warn.bind(this);
        //this.logout = this.logout.bind(this);
        //this.resetTimeout = this.resetTimeout.bind(this);

        //for (var i in this.events) {
        //    window.addEventListener(this.events[i], this.resetTimeout);
        //}

        //this.setTimeout();
    }

    clearTimeout() {
        if (this.warnTimeout) clearTimeout(this.warnTimeout);
        if (this.logoutTimeout) clearTimeout(this.logoutTimeout);
    }

    setTimeout() {
        this.warnTimeout = setTimeout(this.warn, 16 * 1000);
        this.logoutTimeout = setTimeout(this.logout, 30 * 1000);
    }

    resetTimeout() {
        this.clearTimeout();
        this.setTimeout();
    }

    warn() {
        if (this.props.store.userInfo) {
            alert("You will be logged out automatically in 1 minute.");
        }
    }

    logout = () => {
        if (this.props.store.userInfo) {
            // Send a logout request to the API
            console.log("Sending a logout request to the API...");
            //this.setState({ logginStatus: false });
            var me = this;
            fetch('/api/Account/SignOut')
                .then(function (data) { return data.json(); })
                .then(function (jjson) {
                    if (jjson.result == 'ok')
                        me.props.store.set('userInfo', null);
                    me.props.history.push('/');
                });
            // this.destroy(); // Cleanup
        }
    }

    destroy() {
        this.clearTimeout();

        for (var i in this.events) {
            window.removeEventListener(this.events[i], this.resetTimeout);
        }
    }



    //componentDidMount() {
    //    if (window.Stripe) {
    //        this.setState({ stripe: window.Stripe('pk_test_xMs3Jv9wFZpbOCgOih2TK2nW00bxku1Y8Q') });
    //    } else {
    //        document.querySelector('#stripe-js').addEventListener('load', () => {
    //            // Create Stripe instance once Stripe.js loads
    //            this.setState({ stripe: window.Stripe('pk_test_xMs3Jv9wFZpbOCgOih2TK2nW00bxku1Y8Q') });
    //        });
    //    }
    //}
    ////apiKey="pk_test_xMs3Jv9wFZpbOCgOih2TK2nW00bxku1Y8Q">
    render() {
        //return (
        //    <StripeProvider stripe={this.state.stripe}>
        //        <div className="example">
        //            <h1>React Stripe Elements Example</h1>
        //            <Elements>
        //                <CheckoutForm />
        //            </Elements>
        //        </div>
        //    </StripeProvider>
        //);


        return (
            <BrowserRouter>
                <Switch>
                    <Route exact path='/' render={(match) => <div><NavMenu {...match}
                        ref={el => this.navBarRef = el}
                    />
                        <SideBarLayout {...match}
                            sideBarContent={null}//CalendarSideBar
                            bodyContent={Calendar}
                            onSideBarDropDownValueChange={value => { this.setState({ chapterFilter: value }) }}
                            onBodyDropDownValueChange={value => this.setState({ chapterFilter: value })}
                            chapterFilter={this.state.chapterFilter}
                            clearChapterFilter={() => this.setState({ chapterFilter: [] })}
                        />
                    </div>} />
                    <Route path='/events' render={(match) => <div><NavMenu {...match} /><SideBarLayout {...match} sideBarContent={EventsSideBar} bodyContent={Events} /></div>} />
                    <Route path='/members' render={(match) => <div><NavMenu {...match} /><SideBarLayout {...match} sideBarContent={MembersSideBar} bodyContent={Members} /></div>} />
                    <Route path='/event-edit/:id' render={(match) => <div><NavMenu {...match} /><SimpleLayout><Event {...match} /></SimpleLayout></div>} />
                    <Route path='/event-attend/:id' render={(match) => <div><NavMenu {...match} /><SimpleLayout><MemberEvent {...match} /></SimpleLayout></div>} />
                    <Route path='/event-assign' render={(match) => <div><NavMenu {...match} /><SimpleLayout><MemberEvent {...match} /></SimpleLayout></div>} />
                    <Route path='/new-event' render={(match) => <div><NavMenu {...match} /><SimpleLayout><Event {...match} /></SimpleLayout></div>} />
                    {/*<Route path='/chapters' render={(match) => <div><NavMenu {...match} /><SimpleLayout><Chapters {...match} /></SimpleLayout></div>} />*/}
                    <Route path='/services' render={(match) => <div><NavMenu {...match} /><SideBarLayout {...match} sideBarContent={ServiceSideBar} bodyContent={Services} /></div>} />
                    <Route path='/new-member' render={(match) => <div><NavMenu {...match} /><SimpleLayout><Member {...match} /></SimpleLayout></div>} />
                    <Route path='/new-admin' render={(match) => <div><NavMenu {...match} /><SimpleLayout><Admin {...match} /></SimpleLayout></div>} />
                    <Route path='/profile' render={(match) => <div><NavMenu {...match} /><SimpleLayout><Member {...match} /></SimpleLayout></div>} />
                    <Route path='/member/:id' render={(match) => <div><NavMenu {...match} /><SimpleLayout><Member {...match} /></SimpleLayout></div>} />
                    <Route path='/admin/:id' render={(match) => <div><NavMenu {...match} /><SimpleLayout><Admin {...match} /></SimpleLayout></div>} />
                    <Route path='/SignIn' render={(match) => <div><SimpleLayout><SignIn {...match} /></SimpleLayout></div>} />
                    <Route path='/SignUp' render={(match) => <div><SimpleLayout><SignUp {...match} /></SimpleLayout></div>} />
                    <Route path='/ForgotPassword' render={(match) => <div><SimpleLayout><PasswordReset {...match} /></SimpleLayout></div>} />
                    <Route path='/PasswordReset/:token' render={(match) => <div><SimpleLayout><PasswordReset {...match} /></SimpleLayout></div>} />
                    <Route path='/EmailConfirmation/:id/:token' render={(match) => <div><SimpleLayout><SignIn {...match} /></SimpleLayout></div>} />

                    <Route path='/event-types' render={(match) => <div><NavMenu {...match} /><SimpleLayout><EventTypes {...match} /></SimpleLayout></div>} />
                    <Route path='/edit-event-type/:id' render={(match) => <div><NavMenu {...match} /><SimpleLayout><EventType {...match} /></SimpleLayout></div>} />
                    <Route path='/new-event-type' render={(match) => <div><NavMenu {...match} /><SimpleLayout><EventType {...match} /></SimpleLayout></div>} />

                    <Route path='/help' render={(match) => <div><NavMenu {...match} /><SimpleLayout><ContactUs {...match} /></SimpleLayout></div>} />

                    <Route path='/reports' render={(match) => <div><NavMenu {...match} /><SimpleLayout><ReportsList {...match} /></SimpleLayout></div>} />
                    <Route path='/event-view/:id' render={(match) => <div><NavMenu {...match} /><SimpleLayout><EventDemo {...match} /></SimpleLayout></div>} />
                    <Route path='/new-chapter' render={(match) => <div><NavMenu {...match} /><SimpleLayout><Chapter {...match} /></SimpleLayout></div>} />
                    <Route path='/edit-chapter/:id' render={(match) => <div><NavMenu {...match} /><SimpleLayout><Chapter {...match} /></SimpleLayout></div>} />

                    <Route path='/new-service' render={(match) => <div><NavMenu {...match} /><SimpleLayout><Service {...match} /></SimpleLayout></div>} />
                    <Route path='/edit-service/:id' render={(match) => <div><NavMenu {...match} /><SimpleLayout><Service {...match} /></SimpleLayout></div>} />

                    <Route path='/order-checkout/:id' render={(match) => <div><NavMenu {...match} /><SimpleLayout><Checkout {...match} /></SimpleLayout></div>} />

                    <Route path='/Report/Members' render={(match) => <div><NavMenu {...match} /><SimpleLayout><MembersReport {...match} /></SimpleLayout></div>} />
                    <Route path='/Report/EventsByType' render={(match) => <div><NavMenu {...match} /><SimpleLayout><EventsByType {...match} /></SimpleLayout></div>} />
                    <Route path='/Report/VeteransBySite' render={(match) => <div><NavMenu {...match} /><SimpleLayout><VeteransBySite {...match} /></SimpleLayout></div>} />
                    <Route path='/Report/VeteransAttendence' render={(match) => <div><NavMenu {...match} /><SimpleLayout><VeteransAttendence {...match} /></SimpleLayout></div>} />
                    <Route path='/Report/VeteransByEventType' render={(match) => <div><NavMenu {...match} /><SimpleLayout><VeteransByEventType {...match} /></SimpleLayout></div>} />
                    <Route path='/Report/PaymentReport' render={(match) => <div><NavMenu {...match} /><SimpleLayout><PaymentReport {...match} /></SimpleLayout></div>} />

                    <Route path='/test' component={TestPage} />
                </Switch>
            </BrowserRouter>
        );
    }
}

export default createStore(withStore(App))



// WEBPACK FOOTER //
// ./src/App.js